import { createContext } from 'react';

const DataContext = createContext({ menu: [], route: [] });

export default DataContext;
